/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeEditrecipesCtrl
 */
angular.module('mercury.modules.stock.stocktake')
.controller('StockStocktakeEditrecipesCtrl', ["dialog", "ngToast", "$q", "$scope", "Stocktakes", "StockUnits", "$stateParams", "title", function(dialog, ngToast, $q, $scope, Stocktakes, StockUnits, $stateParams, title) {
  title.set('Edit Stocktake Recipes');

  $scope.stocktakeRecipes = Stocktakes.getRecipes($stateParams.id);
  $scope.units = StockUnits.getAllActive();

  $scope.loading = $q.all([$scope.stocktakeRecipes.$promise, $scope.units.$promise]);
  $scope.loading.catch(function() {
    $state.go('Stock.Stocktakes');
  });

  $scope.stocktakeId = $stateParams.id;

  $scope.updateRecipeCount = function(recipe, index) {
    if ($scope.stocktakeRecipesForm['recipeCount' + index].$invalid) {
      ngToast.dismiss();
      ngToast.danger('Invalid stocktake recipe line');
      return;
    }

    Stocktakes.updateRecipe(recipe);
  };

  $scope.updateRecipeUnit = function(recipe, index, newUnit) {
    if ($scope.stocktakeRecipesForm['recipeCount' + index].$invalid) {
      ngToast.dismiss();
      ngToast.danger('Invalid stocktake recipe line');
      return;
    }

    //Re-calculate the counted and total quantities so they will be unchanged after the ratio change.
    recipe.countQuantity = (recipe.countQuantity / recipe.unitRatio) * newUnit.ratio;
    recipe.unitRatio = newUnit.ratio;

    Stocktakes.updateRecipe(recipe);
  };
}]);
